import { useTranslationInterface } from 'utils/hooks/useTranslation';

export const useTranslation = () => useTranslationInterface('legacySegmentation');
